/**
 * @generated SignedSource<<d075fbb80ea4e7eb5b516af9127539aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type ThreadSubscriptionFormAction = "NONE" | "SUBSCRIBE" | "UNSUBSCRIBE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SubscriptionSectionRefetchableFragment$data = {
  readonly id: string;
  readonly viewerThreadSubscriptionFormAction: ThreadSubscriptionFormAction | null | undefined;
  readonly " $fragmentType": "SubscriptionSectionRefetchableFragment";
};
export type SubscriptionSectionRefetchableFragment$key = {
  readonly " $data"?: SubscriptionSectionRefetchableFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubscriptionSectionRefetchableFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./SubscriptionSectionRefetchableFragmentQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "SubscriptionSectionRefetchableFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerThreadSubscriptionFormAction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "503d86fd24a4cf3bea72e4a6aca5b17f";

export default node;
